// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__bCS8b","title":"ClientCherryInfo_title__1e4db","itemText":"ClientCherryInfo_itemText__2qXVX"};